<template>
<v-container v-if="$store.state.is_login" style="min-height:100%">

   <v-dialog  v-model="transaction_modal" persistent  max-width="290" >
      <v-card v-if="transaction.status == 100">
           <v-icon
      style="font-size: 70px;text-align: center;margin: 0 auto;display: flex;width: 100px;padding: 20px 0 0 0;"
      color="green darken-2"
    >
      mdi-check-circle
    </v-icon>
        <v-card-title style="font-size:16px;color:green;text-align:center;display: block;font-weight: bold;">
         پرداخت با موفقیت انجام شد
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col style="text-align:right" cols="6">نام بسته</v-col>
            <v-col style="text-align:left" cols="6">
              <p class="my-0" v-if="transaction.plan_id == 1">اشتراک 6 ماهه</p>
              <p class="my-0" v-if="transaction.plan_id == 2">اشتراک 3 ماهه</p>
              <p class="my-0" v-if="transaction.plan_id == 3">اشتراک 1 ماهه</p>
            </v-col>

            <v-col class="py-0" cols="12"><v-divider></v-divider></v-col>

             <v-col style="text-align:right" cols="6"> مبلغ</v-col>
               <v-col style="text-align:left" cols="6"> {{transaction.price}} تومان</v-col>

                  <v-col class="py-0" cols="12"><v-divider></v-divider></v-col>
  <v-col style="text-align:right" cols="6"> درگاه</v-col>
               <v-col style="text-align:left" cols="6">زرین پال</v-col>

    <v-col class="py-0" cols="12"><v-divider></v-divider></v-col>

                <v-col style="text-align:right" cols="6">کد پیگیری</v-col>
            <v-col style="text-align:left" cols="6">{{transaction.refid}}</v-col>
       
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
       
          <v-btn  color="green darken-1" block dark  @click="transaction_modal = false" >   تایید  </v-btn>
        </v-card-actions>
      </v-card>


        <v-card v-if="transaction.status != 100">
           <v-icon
      style="font-size: 70px;text-align: center;margin: 0 auto;display: flex;width: 100px;padding: 20px 0 0 0;"
      color="red darken-2"
    >
      mdi-close-circle
    </v-icon>
        <v-card-title style="font-size:16px;color:red;text-align:center;display: block;font-weight: bold;">
        خطا در پرداخت
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col style="text-align:right" cols="6">نام بسته</v-col>
            <v-col style="text-align:left" cols="6">
              <p class="my-0" v-if="transaction.plan_id == 1">اشتراک 6 ماهه</p>
              <p class="my-0" v-if="transaction.plan_id == 2">اشتراک 3 ماهه</p>
              <p class="my-0" v-if="transaction.plan_id == 3">اشتراک 1 ماهه</p>
            </v-col>

            <v-col class="py-0" cols="12"><v-divider></v-divider></v-col>

             <v-col style="text-align:right" cols="6"> مبلغ</v-col>
               <v-col style="text-align:left" cols="6"> {{transaction.price}} تومان</v-col>

                  <v-col class="py-0" cols="12"><v-divider></v-divider></v-col>
  <v-col style="text-align:right" cols="6"> درگاه</v-col>
               <v-col style="text-align:left" cols="6">زرین پال</v-col>

    <v-col class="py-0" cols="12"><v-divider></v-divider></v-col>

                <v-col style="text-align:right" cols="6">کد پیگیری</v-col>
            <v-col style="text-align:left" cols="6">{{transaction.refid}}</v-col>
       
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
       
          <v-btn  color="red darken-1" block dark  @click="transaction_modal = false" >   تایید  </v-btn>
        </v-card-actions>
      </v-card>


    </v-dialog>

    <v-row>

        <v-col cols="12" sm="12" >
            <v-card class="py-3 px-3" outlined>
<!-- <v-avatar>
      <img
        src="https://cdn.vuetifyjs.com/images/john.jpg"
        alt="John"
      >
      
    </v-avatar> -->
    

     {{$store.state.user.first_name}}
    {{$store.state.user.last_name}}
   <span style="float: left;padding: 0px;font-size: 14px;margin: -9px 0px 0px;">   
     <span style="font-size: 30px;font-family: system-ui;font-weight: bold;color: #999;vertical-align: sub;" class="score">{{user.score}}</span> امتیاز</span>
  
</v-card>

        </v-col>

<v-col v-if="user.plan != 0" cols="12" sm="12" class="py-0 mb-3">
   <v-card class="py-3 px-3" outlined>
     <p>
       <span v-if="user.plan == 1">اشتراک شش ماهه</span>
       <span v-if="user.plan == 2">اشتراک سه ماهه</span>
       <span v-if="user.plan == 3">اشتراک یک ماهه</span>
     </p>
    انقصا {{ user.plan_expire | moment("jDD jMMMM  jYYYY") }}
<br>
 {{ $moment(user.plan_expire).toNow(true) }} مانده

</v-card>

</v-col>
        

<v-col v-if="loading == true" cols="12" sm="12" class="py-0">

   <v-alert v-if="user.active == '1'" class="mb-2" dense text outlined type="warning">
    <strong>در انتظار تایید پروفایل کاربری</strong>
    </v-alert>


 <v-alert v-if="user.active == '1' || branding.province_id == 0 || (branding.cities.length == 1 && branding.cities[0] == '') || $store.state.agent_brands.length == 0 || selected_devices.length == 0"
      dense
      text
      outlined
      type="warning"
    >
    <strong>اطلاعات تماس شما نمایش داده نمی شود. لطفا موارد زیر را بررسی کنید</strong>
  
    <ul>
<li v-if="branding.province_id == 0">استان فعالیت شما انتخاب نشده است</li>
<li v-if="branding.cities.length == 1 && branding.cities[0] == ''">  شهر فعالیت شما انتخاب نشده است</li>
<li v-if="$store.state.agent_brands.length == 0">هیچ برندی را برای فعالیت انتخاب نکرده اید</li>
<li v-if="selected_devices.length == 0">هیچ دستگاهی را برای فعالیت انتخاب نکرده اید</li>
<li v-if="user.plan == 0">شما هیچ یک از پلن های اشتراک را فعال نکرده اید</li>
<li v-if="user.active == '1'">حساب کاربری شما تایید نشده است</li>
    </ul>
 
    </v-alert>
</v-col>
<v-col v-if="province.length > 0" cols="12" sm="12" class="pt-0">
<v-card class="py-3 px-3" outlined>
  <v-list class="py-0" disabled>
     
      <v-list-item-group color="primary">
        <v-list-item class="pr-0">
          <v-list-item-icon class="ml-2 my-0">
            <v-icon class="text-h3">mdi-trophy-award</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-h5">
              
                <span class="text-subtitle-1">رتبه فعلی در  {{province[0].name}}</span><span style="float:left"></span>  
                </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
</v-card>

</v-col>
    </v-row>
</v-container>
</template>
<script>
export default {
     data: () => ({
       loading : false,
      transaction: [],
      selected_devices : [],
      transaction_modal:  false,
 
    }),
        computed: {
      province () {
        if(this.user.province_id != 0){
  return this.$store.state.cities.filter(
          city => city.id == this.user.province_id);
        }else{
          return []
        }
  
      },

       branding (){
   return this.$store.state.user_branding;
 },

                 user (){  
         return this.$store.state.user}
        },
  mounted: function () {
    const _this = this
        
        
this.loading = false

     var senddata = {  data: {  data: ['select', 'brands', '*'] }, actions: ['get'] };
     this.api_get(senddata).then(data => {
       
          data.data.forEach(element => {
         element['devices'] = []
       });

                 senddata = {data: {  data: ['select', 'agent_branding_brands', '*',{branding_id:this.branding.id}] } , actions: ['get'] };
    _this.api_get(senddata).then(result => {
      
result.data.forEach((element,index) => {
        data.data.forEach((e,i) => {
 if(element.brand_id == e.id){
  data.data[i]['devices'] = result.data[index]['devices'].split(',')
_this.selected_devices[index] = data.data[i]['devices']
}
});
})

_this.$store.state.agent_brands = result.data;
_this.$store.state.agent_brands_changes = result.data;

if(_this.$store.state.agent_brands_changes.length > 0){
 _this.brands = _this.$store.state.agent_brands_changes.map(a => a.brand_id);
}

setTimeout(function(){ 
_this.$store.state.brands = data.data
_this.$store.state.brands_changes = data.data
_this.loading = true
 }, 10);

    })
     })


console.log(this.$route)
if(this.$route.query.pay_id){

      senddata = {  data: {  data: ['select', 'agent_transactions', '*',{id:this.$route.query.pay_id,is_viewed:0}] }, actions: ['get'] };
     this.api_get(senddata).then(data => {
       console.log(data)
if(data.data.length > 0){
       this.transaction = data.data[0]

_this.transaction_modal = true

     senddata = {  data: {  data: ['update', 'agent_transactions', {is_viewed : 1},{id: this.$route.query.pay_id}
    ]}, actions: ['insert'] };
 
     this.api_get(senddata).then(() => {

     })

}
     })


}

  }
}
</script>